"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Apollo = void 0;
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const MoonExpansion_1 = require("../../moon/MoonExpansion");
const Resources_1 = require("../../Resources");
class Apollo extends Card_1.Card {
    constructor() {
        super({
            name: CardName_1.CardName.APOLLO,
            cardType: CardType_1.CardType.LEADER,
            metadata: {
                cardNumber: 'L35',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.opgArrow().text('ACTIVATE THE BELOW ABILITY');
                    b.br.br;
                    b.moonColony().any.moonMine().any.moonRoad().any.nbsp().colon().megacredits(3);
                    b.br.br;
                }),
                description: 'Once per game, gain 3 M€ for each tile on The Moon.',
            },
        });
        this.isDisabled = false;
    }
    play() {
        return undefined;
    }
    canAct() {
        return this.isDisabled === false;
    }
    action(player) {
        const moonSpacesCount = MoonExpansion_1.MoonExpansion.tiles(player.game).length;
        player.addResource(Resources_1.Resources.MEGACREDITS, moonSpacesCount * 3, { log: true });
        this.isDisabled = true;
        return undefined;
    }
}
exports.Apollo = Apollo;
//# sourceMappingURL=Apollo.js.map